// app/javascript/controllers/calendar_highlight_controller.js
// Rule: Use Hotwire (Turbo and Stimulus) for dynamic, SPA-like interactions
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    arrivalDates: Array,
    departureDates: Array,
    currentDate: String
  }

  connect() {
    console.log('Calendar highlight controller connected')
    this.highlightDates()
  }

  highlightDates() {
    // Find all date cells in the date picker
    const dateInputs = document.querySelectorAll('input[type="date"]')
    
    if (dateInputs.length === 0) return
    
    // Create a tooltip to show reservation counts
    this.createTooltip()
    
    // Convert date strings to Date objects for comparison
    const arrivalDates = this.arrivalDatesValue.map(d => new Date(d))
    const departureDates = this.departureDatesValue.map(d => new Date(d))
    
    // Add event listener to show custom calendar with highlighted dates
    dateInputs.forEach(input => {
      input.addEventListener('click', () => {
        // Calendar implementation would go here in a full implementation
        // For now, we'll just log the dates with reservations
        console.log('Dates with arrivals:', this.arrivalDatesValue)
        console.log('Dates with departures:', this.departureDatesValue)
      })
    })
  }
  
  createTooltip() {
    const tooltip = document.createElement('div')
    tooltip.id = 'reservation-date-tooltip'
    tooltip.className = 'hidden absolute z-50 bg-white dark:bg-zinc-800 p-2 rounded-md shadow-lg text-xs border border-zinc-200 dark:border-zinc-700'
    document.body.appendChild(tooltip)
  }
}
